import MediumType from "./MediumType";
import MediumAudience from "./MediumAudience";

import Model from "./Model";

export default class Media extends Model {
  static type = "media";

  name!: string;
  mediumTypeId!: string;
  mediumType!: MediumType;
  mediaAudiences!: MediumAudience[];
  budget?: number;
  parentId?: string;
  parentName?: string;
}
